import React from 'react';
import { CollapseSection, FieldSet } from '@alfa-retail-react/components';

const antiFraudSteps = [
    {
        value: 'Не оформляйте кредит, если вас попросил открыть кредит другой человек, который позвонил и сообщил, что кто-то якобы оформляет или уже оформил кредит на ваше имя.',
        className: 'advantagesListItem',
    },
    {
        value: 'Вам сообщили, что кто-то неизвестный открывает кредит на ваше имя.',
        className: 'advantagesListItem',
    },
    {
        value: 'Вам сообщили, что вы участвуете в операции правоохранительных органов по выявлению недобросовестных работников банка. И вам запретили сообщать об этом, в том числе своим родственникам и работникам банка.',
        className: 'advantagesListItem',
    },
    {
        value: 'Вам позвонили и сообщили, что полученный кредит можно перевести на безопасный счёт, а кредит аннулировать.',
        className: 'advantagesListItem',
    },
    {
        value: 'Вам сообщили, что мошенники знают ваши личные данные и всё про ваши действия в банке.',
        className: 'advantagesListItem',
    },
    {
        value: 'Сомневаетесь или боитесь, обратитесь в ближайшее отделение милиции.',
        className: 'advantagesListItem',
    },
    {
        value: 'Сотрудники органов внутренних дел и представители банка никогда не звонят с иностранных номеров или в мессенджерах, чтобы выявить или задержать недобросовестных работников банка.',
        className: 'advantagesListItem',
    },
    {
        value: 'Вы можете потерять деньги, если будете вовлекаться в схемы мошенников.',
        className: 'advantagesListItem',
    },
];

export const FraudNotification = () => {
    return (
        <CollapseSection
            className="IntroFraudNotification"
            header="Остерегайтесь мошенников"
            open={false}
        >
            <FieldSet className="advantagesList" fieldsProps={antiFraudSteps} />
        </CollapseSection>
    );
};
